import { defineStore } from 'pinia'
import { reactive, toRaw, watch } from 'vue'
import { safeLocalStorage, isClient } from '@/composables/useSSR'

export const useClientInfoStore = defineStore('clientInfo', () => {
  const state = reactive({
    visibleNav: true
  })

  // Only access localStorage on client
  if (isClient) {
    const storage = safeLocalStorage()
    if (storage) {
      const localState = storage.getItem('clientInfo')
      if (localState) {
        state.visibleNav = (JSON.parse(localState) as typeof state).visibleNav
      } else {
        storage.setItem('clientInfo', JSON.stringify(toRaw(state)))
      }

      watch(state, () => {
        storage.setItem('clientInfo', JSON.stringify(toRaw(state)))
      })
    }
  }

  function getClientInfo() {
    return toRaw(state)
  }

  return { state, getClientInfo }
})
